import useSkuVenuePermissions from 'features/Sku/Items/useSkuVenuePermissions';

// The single read-only switch for every modifier surface: integrated venues author their
// modifiers in the POS, so anything rendered under this feature must stay inert for them.
const useModifiersReadOnly = () => {
  const { isIntegrated, integrationName } = useSkuVenuePermissions();
  return { isReadOnly: isIntegrated, integrationName };
};

export default useModifiersReadOnly;
